// extracted by mini-css-extract-plugin
export default {"icon":"_1FrOC","unreadCircle":"_30tmV"};